/* VB · complementos del carrito (vb.js gestiona abrir/cerrar, cantidades y re-render).
   - Guarda la nota del pedido en /cart/update.js
   - Atrapa el foco dentro del cajón abierto y lo devuelve al botón que lo abrió
   - Cambio de talla en la línea, sugeridos con talla, barra del carrusel, favoritos y fecha de entrega */
(() => {
  if (window.__vbCartExtras) return;
  window.__vbCartExtras = true;
  const root = () => (window.VB && VB.routes && VB.routes.root) || '/';

  let timer;
  document.addEventListener('input', (e) => {
    const note = e.target.closest('[data-vb-cart-note]');
    if (!note) return;
    clearTimeout(timer);
    timer = setTimeout(() => {
      document.querySelectorAll('[data-vb-cart-note]').forEach((n) => { if (n !== note) n.value = note.value; });
      fetch(`${root().replace(/\/$/, '')}/cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: note.value }),
      });
    }, 400);
  });

  const drawer = () => document.querySelector('[data-vb-cart-drawer]');
  const focusables = (el) => [...el.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, summary, [tabindex]:not([tabindex="-1"])')]
    .filter((n) => n.offsetParent !== null);

  let opener = null;
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-vb-cart-open], [data-vb-product-form] [type="submit"]');
    if (b) opener = b;
  }, true);

  document.addEventListener('keydown', (e) => {
    const d = drawer();
    if (e.key !== 'Tab' || !d || !d.classList.contains('is-open')) return;
    const f = focusables(d);
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (!d.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
    else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  const d = drawer();
  if (d) {
    new MutationObserver(() => {
      if (!d.classList.contains('is-open') && opener && document.contains(opener)) {
        opener.focus({ preventScroll: true });
        opener = null;
      }
    }).observe(d, { attributes: true, attributeFilter: ['class'] });
    // Al re-renderizar el contenido, mantener el foco dentro del cajón.
    d.addEventListener('focusout', () => requestAnimationFrame(() => {
      if (d.classList.contains('is-open') && !d.contains(document.activeElement)) d.focus({ preventScroll: true });
    }));
  }

  /* ---------- Carrito lateral (sections/vb-cart-drawer.liquid) ---------- */
  const base = () => root().replace(/\/$/, '');
  const post = (url, body) => fetch(`${base()}${url}`, {
    method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body),
  }).then(async (r) => { const j = await r.json(); if (!r.ok) throw new Error(j.description || j.message || 'Error'); return j; });
  const lineError = (lineEl, msg) => {
    if (!lineEl) return;
    lineEl.querySelector('.vb-cart-line__error')?.remove();
    const p = document.createElement('p');
    p.className = 'vb-cart-line__error'; p.setAttribute('role', 'alert'); p.textContent = msg;
    lineEl.appendChild(p);
  };

  /* Tras añadir desde «Combínalo»: carrito completo → código de Combínalo (syncPacks repinta el cajón) → repintado */
  const syncUpsell = async () => {
    const V = window.VB;
    const cart = await fetch(`${V.routes.cart}.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json()).catch(() => null);
    if (cart && V.cart.syncPacks) await V.cart.syncPacks(cart).catch(() => {});
    await V.cart.refresh();
  };

  document.addEventListener('click', async (e) => {
    // Cambiar de talla: añade la nueva (con las mismas propiedades y cantidad) y, si entra, quita la vieja
    const sz = e.target.closest('[data-vb-line-variant]');
    if (sz && !sz.disabled) {
      e.preventDefault();
      const lineEl = sz.closest('[data-vb-line]');
      lineEl?.classList.add('is-loading');
      let props = {};
      try { props = JSON.parse(sz.dataset.props || '{}'); } catch (_) {}
      try {
        const qty = Number(sz.dataset.qty || 1);
        await post('/cart/add.js', { items: [{ id: Number(sz.dataset.vbLineVariant), quantity: qty, properties: props }] });
        // La clave de la línea cambia al recalcular descuentos: se busca la vieja por variante + propiedades
        const cart = await fetch(`${base()}/cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());
        const same = (a, b) => JSON.stringify(a || {}) === JSON.stringify(b || {});
        const old = cart.items.find((i) => String(i.variant_id) === sz.dataset.old && same(i.properties, props));
        if (old) await post('/cart/change.js', { id: old.key, quantity: Math.max(0, old.quantity - qty) });
        await window.VB.cart.refresh();
      } catch (err) {
        lineEl?.classList.remove('is-loading');
        lineError(lineEl, err.message);
      }
      return;
    }
    // Sugeridos: elegir talla
    const us = e.target.closest('.vb-cdu__size');
    if (us && !us.disabled) {
      const card = us.closest('[data-vb-cdu-card]');
      card.querySelectorAll('.vb-cdu__size').forEach((b) => { const on = b === us; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', String(on)); });
      card.querySelector('[data-vb-cdu-add]').dataset.vbCduAdd = us.dataset.variant;
      return;
    }
    // Combínalo: «Añadir todo» (_upsell=all → VBCOMBO10 en VB.cart.syncPacks)
    const all = e.target.closest('[data-vb-cdu-all]');
    if (all) {
      e.preventDefault();
      all.disabled = true;
      try {
        const ids = all.dataset.vbCduAll.split(',').filter(Boolean);
        await window.VB.cart.add(ids.map((id) => ({ id: Number(id), quantity: 1, properties: { _upsell: 'all' } })));
        await syncUpsell();
      } catch (err) { all.disabled = false; all.title = err.message; }
      return;
    }
    // Sugeridos: añadir (en «Combínalo» con _upsell=item → VBCOMBO5)
    const add = e.target.closest('[data-vb-cdu-add]');
    if (add) {
      e.preventDefault();
      add.disabled = true;
      const sec = add.closest('[data-vb-cart-section]');
      const tag = add.dataset.vbCduTag;
      try {
        await window.VB.cart.add([{ id: Number(add.dataset.vbCduAdd), quantity: 1, ...(tag ? { properties: { _upsell: tag } } : {}) }]);
        if (tag) await syncUpsell(); else await window.VB.cart.refresh();
        if (sec && !document.activeElement?.closest('[data-vb-cart-section]')) sec.querySelector('.vb-cdl__name, [data-vb-cart-close]')?.focus({ preventScroll: true });
      }
      catch (err) { add.disabled = false; add.title = err.message; }
      return;
    }
    // Favoritos (guardados en este navegador)
    const fav = e.target.closest('[data-vb-fav]');
    if (fav) {
      e.preventDefault();
      const list = favs();
      const id = fav.dataset.vbFav;
      const i = list.indexOf(id);
      if (i > -1) list.splice(i, 1); else list.push(id);
      try { localStorage.setItem('vb:favs', JSON.stringify(list)); } catch (_) {}
      document.dispatchEvent(new CustomEvent('vb:favs:changed', { detail: list }));
      hydrate();
    }
  });

  /* Tras +, −, eliminar o cambiar de talla el cajón se repinta: el foco vuelve al control equivalente */
  let refocus = null;
  document.addEventListener('click', (e) => {
    const q = e.target.closest('[data-vb-line-qty]');
    const v = e.target.closest('[data-vb-cart-drawer] [data-vb-line-variant]');
    if (q) refocus = { sel: `[data-line="${q.dataset.line}"].${q.classList[0]}`, label: q.getAttribute('aria-label'), root: q.closest('[data-vb-cart-section]')?.dataset.vbCartSection };
    else if (v) refocus = { size: v.textContent.trim() };
    if (q || v) { const mine = refocus; setTimeout(() => { if (refocus === mine) refocus = null; }, 6000); }
  }, true);
  const restoreFocus = (sec) => {
    if (!refocus) return;
    const r = refocus; refocus = null; if (r.root) sec = document.querySelector(`[data-vb-cart-section="${r.root}"]`) || sec;
    let el = null;
    if (r.size) el = [...sec.querySelectorAll('.vb-cdl__size.is-on')].find((b) => b.textContent.trim() === r.size);
    else el = [...sec.querySelectorAll(r.sel)].find((b) => !r.label || b.getAttribute('aria-label') === r.label) || sec.querySelector('.vb-cdl__qbtn, [data-vb-cart-close]');
    if (!el && !sec.closest('[data-vb-cart-drawer]')) { el = sec.querySelector('.vb-ch__title'); el?.setAttribute('tabindex', '-1'); }
    (el || document.querySelector('[data-vb-cart-close]'))?.focus({ preventScroll: true });
  };

  const favs = () => { try { const v = JSON.parse(localStorage.getItem('vb:favs') || '[]'); return Array.isArray(v) ? v.map(String) : []; } catch (_) { return []; } };

  /* Fecha de entrega: días laborables (sin findes, festivos de la lista ni Viernes Santo); tras la hora límite cuenta desde mañana */
  const delivery = (box) => {
    const out = box.querySelector('[data-tpl]');
    if (!out) return;
    const [min, max] = (box.dataset.days || '1,2').split(',').map(Number);
    const now = new Date();
    const start = new Date(now);
    if (now.getHours() >= Number(box.dataset.cutoff || 12)) start.setDate(start.getDate() + 1);
    const hol = (box.dataset.holidays || '').split(/[\s,;]+/).filter(Boolean);
    const pad = (n) => String(n).padStart(2, '0');
    const goodFriday = (y) => {
      const a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e2 = b % 4, f = Math.floor((b + 8) / 25);
      const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4;
      const l = (32 + 2 * e2 + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
      const month = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1;
      const gf = new Date(y, month - 1, day - 2);
      return `${pad(gf.getMonth() + 1)}-${pad(gf.getDate())}`;
    };
    const off = (d) => {
      if ([0, 6].includes(d.getDay())) return true;
      const md = `${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
      return hol.includes(md) || hol.includes(`${d.getFullYear()}-${md}`) || md === goodFriday(d.getFullYear());
    };
    const addBiz = (d0, n) => { const d = new Date(d0); while (off(d)) d.setDate(d.getDate() + 1); let left = n; while (left > 0) { d.setDate(d.getDate() + 1); if (!off(d)) left -= 1; } return d; };
    const a = addBiz(start, min), b = addBiz(start, max);
    const lang = document.documentElement.lang || 'es';
    // Día + mes en el formato de cada idioma (es «27 de octubre», en «October 27», fr «27 octobre», de «27. Oktober», it «27 ottobre»)
    const dm = (d) => d.toLocaleDateString(lang, { day: 'numeric', month: 'long' });
    // Mismo mes: solo el día en la primera fecha («del 26 al 27 de octubre»), salvo en inglés, que lleva mes en ambas
    const from = a.getMonth() === b.getMonth() && !/^en/i.test(lang) ? `${a.getDate()}` : dm(a);
    out.textContent = (out.dataset.tpl || '').replace('[desde]', from).replace('[hasta]', dm(b));
    box.hidden = false;
  };

  /* Barra bajo los sugeridos: refleja el desplazamiento del carril (Figma 14277:73605: 366 + tirador de 80) */
  const bar = (wrap) => {
    const track = wrap.querySelector('[data-vb-cdu-track]');
    const barEl = wrap.querySelector('.vb-cdu__bar');
    const thumb = wrap.querySelector('[data-vb-cdu-thumb]');
    if (!track || !thumb) return;
    const sync = () => {
      const max = track.scrollWidth - track.clientWidth;
      barEl.hidden = max <= 2;
      const room = barEl.clientWidth - thumb.offsetWidth;
      thumb.style.transform = `translateX(${max > 0 ? (track.scrollLeft / max) * room : 0}px)`;
    };
    if (!track.__vbBar) { track.__vbBar = true; track.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true }); }
    sync();
  };

  const hydrate = () => {
    const sec = document.querySelector('[data-vb-cart-section="vb-cart-drawer"]');
    if (!sec) return;
    restoreFocus(sec);
    sec.querySelectorAll('[data-vb-cd-delivery]').forEach(delivery);
    sec.querySelectorAll('[data-vb-cdu]').forEach(bar);
    const list = favs();
    sec.querySelectorAll('[data-vb-fav]').forEach((b) => b.setAttribute('aria-pressed', String(list.includes(b.dataset.vbFav))));
  };
  const sec0 = document.querySelector('[data-vb-cart-section="vb-cart-drawer"]');
  if (sec0) new MutationObserver(hydrate).observe(sec0, { childList: true });
  document.addEventListener('vb:cart:updated', () => requestAnimationFrame(hydrate));
  if (d) new MutationObserver(() => { if (d.classList.contains('is-open')) requestAnimationFrame(hydrate); }).observe(d, { attributes: true, attributeFilter: ['class'] });
  window.addEventListener('resize', () => document.querySelectorAll('[data-vb-cdu]').forEach(bar));
  hydrate();
})();
